/* eslint-disable @typescript-eslint/ban-types */
import {Injectable} from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';



@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private theme: BehaviorSubject<String>;

  constructor() {
    this.theme = new BehaviorSubject('default');
  }
  setActiveTheme(val) {
    this.theme.next(val);
  }

  getActiveTheme()  {
    return this.theme.asObservable();
 }

}
